import { makeService } from './api';

const service = makeService('payment_methods');

export default service;